import { render, staticRenderFns } from "./filter_source_sentiment.vue?vue&type=template&id=63d5933e&scoped=true"
import script from "./filter_source_sentiment.vue?vue&type=script&lang=js"
export * from "./filter_source_sentiment.vue?vue&type=script&lang=js"
import style0 from "./filter_source_sentiment.vue?vue&type=style&index=0&id=63d5933e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d5933e",
  null
  
)

export default component.exports